import { render, staticRenderFns } from "./HeadingBlock.vue?vue&type=template&id=02d7cc90&scoped=true&"
import script from "./HeadingBlock.vue?vue&type=script&lang=js&"
export * from "./HeadingBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeadingBlock.vue?vue&type=style&index=0&id=02d7cc90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d7cc90",
  null
  
)

export default component.exports